{
  "$schema": "https://zam.app/schemas/v1/kvt-tile.json",
  "tile_id": "de-by:realschule-9-physik-waermelehre",
  "version": "2026.08.1",
  "title": "Wärmelehre (Realschule 9 Bayern)",
  "description": "Geerdetes KVT-Paket für Realschule Bayern Physik 9: Temperatur, thermische Energie, spezifische Wärmekapazität, Aggregatzustände, 1. Hauptsatz der Wärmelehre und Wärmeübertragung.",
  "publisher": "ZAM Curriculum Working Group",
  "published_at": "2026-08-15T21:20:00Z",
  "sources": [
    {
      "uri": "https://www.lehrplanplus.bayern.de/fachlehrplan/realschule/9/physik/wpfg1",
      "checked": "2026-08-15",
      "label": "Realschule Physik 9 (I), Lernbereich 2 Wärmelehre"
    },
    {
      "uri": "https://www.lehrplanplus.bayern.de/fachlehrplan/realschule/9/physik/wpfg2-3",
      "checked": "2026-08-15",
      "label": "Realschule Physik 9 (II/III), Lernbereich 2 Wärmelehre"
    }
  ],
  "atoms": [
    {
      "id": "01K4W9P0000000000000000A01",
      "atom_uri": "urn:zam:atom:01K4W9P0000000000000000A01",
      "namespace": "physik-waerme",
      "slug": "temperatur-thermische-energie-kelvin",
      "title": "Temperatur, thermische Energie und Kelvin-Skala",
      "domain": "schule/physik/waerme",
      "reduction": "classical",
      "typical_age_min": 14.0,
      "prerequisites": [],
      "alignments": [
        {
          "target_uri": "http://www.wikidata.org/entity/Q11466",
          "target_label": "Temperature",
          "alignment_type": "skos:broadMatch",
          "provenance": "manual_curation_v1"
        }
      ],
      "curricula": [
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 9,
          "track": "I",
          "subject": "physik",
          "topic_code": "lb2",
          "topic_title": "Wärmelehre",
          "exam_relevant": true
        },
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 9,
          "track": "II_III",
          "subject": "physik",
          "topic_code": "lb2",
          "topic_title": "Wärmelehre",
          "exam_relevant": true
        }
      ],
      "practice_items": [
        {
          "id": "01K4W9P0000000000000000J01",
          "language": "de",
          "tier": "tier1_fast",
          "bloom_level": 1,
          "question": "Welche Temperatur in Grad Celsius entspricht dem absoluten Nullpunkt (0 Kelvin)?",
          "concept": "-273,15 °C",
          "fast_check": {
            "type": "binary_choice",
            "options": [
              "-273,15 °C",
              "0 °C"
            ],
            "correct_index": 0
          }
        },
        {
          "id": "01K4W9P0000000000000000J02",
          "language": "de",
          "tier": "tier2_synthesis",
          "bloom_level": 2,
          "question": "Erkläre den physikalischen Unterschied zwischen Temperatur T und thermischer Energie (Wärme) auf Teilchenebene und gib die Umrechnung zwischen Celsius und Kelvin an.",
          "concept": "Temperatur = mittlere kinetische Energie; thermische Energie = Summe aller kinetischen Energien; T(K) = ϑ(°C) + 273,15",
          "sample_solution": "Die Temperatur T ist ein Maß für die mittlere kinetische Energie der ungeordneten Teilchenbewegung eines Stoffes. Die thermische Energie (innere Energie) ist die Summe der kinetischen und potenziellen Energien aller Teilchen des Körpers. Die Umrechnung lautet: T [in K] = ϑ [in °C] + 273,15 (Temperaturdifferenzen sind numerisch gleich: ΔT = Δϑ)."
        }
      ]
    },
    {
      "id": "01K4W9P0000000000000000A02",
      "atom_uri": "urn:zam:atom:01K4W9P0000000000000000A02",
      "namespace": "physik-waerme",
      "slug": "spezifische-waermekapazitaet",
      "title": "Spezifische Wärmekapazität und Erwärmung",
      "domain": "schule/physik/waerme",
      "reduction": "classical",
      "typical_age_min": 14.0,
      "prerequisites": [
        {
          "atom_id": "01K4W9P0000000000000000A01",
          "type": "hard",
          "rationale": "Temperaturbegriff und Temperaturdifferenz sind Voraussetzung für die spezifische Wärmekapazität."
        }
      ],
      "alignments": [
        {
          "target_uri": "http://www.wikidata.org/entity/Q130964",
          "target_label": "Specific heat capacity",
          "alignment_type": "skos:broadMatch",
          "provenance": "manual_curation_v1"
        }
      ],
      "curricula": [
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 9,
          "track": "I",
          "subject": "physik",
          "topic_code": "lb2",
          "topic_title": "Wärmelehre",
          "exam_relevant": true
        },
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 9,
          "track": "II_III",
          "subject": "physik",
          "topic_code": "lb2",
          "topic_title": "Wärmelehre",
          "exam_relevant": true
        }
      ],
      "practice_items": [
        {
          "id": "01K4W9P0000000000000000J03",
          "language": "de",
          "tier": "tier1_fast",
          "bloom_level": 1,
          "question": "Besitzt flüssiges Wasser im Vergleich zu den meisten Metallen (z. B. Eisen, Kupfer) eine besonders hohe oder niedrige spezifische Wärmekapazität?",
          "concept": "Besonders hohe Wärmekapazität (c_Wasser ≈ 4,18 kJ/(kg·K))",
          "fast_check": {
            "type": "binary_choice",
            "options": [
              "Eine besonders hohe Wärmekapazität (hervorragender Wärmespeicher)",
              "Eine besonders niedrige Wärmekapazität"
            ],
            "correct_index": 0
          }
        },
        {
          "id": "01K4W9P0000000000000000J04",
          "language": "de",
          "tier": "tier2_synthesis",
          "bloom_level": 2,
          "question": "Wie lautet die Grundgleichung der Wärmelehre zur Berechnung der abgegebenen oder aufgenommenen Wärme Q und welche Einheit hat die spezifische Wärmekapazität c?",
          "concept": "Q = c * m * ΔT in Joule; Einheit kJ/(kg·K) oder J/(kg·K)",
          "sample_solution": "Die thermische Energie berechnet sich nach Q = c * m * ΔT, wobei c die stoffspezifische Wärmekapazität, m die Masse und ΔT die Temperaturänderung ist. Die Einheit von c ist J / (kg * K) bzw. kJ / (kg * K). Für flüssiges Wasser gilt c ≈ 4,19 kJ / (kg * K)."
        }
      ]
    },
    {
      "id": "01K4W9P0000000000000000A03",
      "atom_uri": "urn:zam:atom:01K4W9P0000000000000000A03",
      "namespace": "physik-waerme",
      "slug": "aggregatzustaende-latente-waerme",
      "title": "Aggregatzustandsänderungen und latente Wärme",
      "domain": "schule/physik/waerme",
      "reduction": "classical",
      "typical_age_min": 14.0,
      "prerequisites": [
        {
          "atom_id": "01K4W9P0000000000000000A02",
          "type": "hard",
          "rationale": "Wärmeenergieübertragung ist Voraussetzung für Schmelz- und Verdampfungsvorgänge."
        }
      ],
      "alignments": [
        {
          "target_uri": "http://www.wikidata.org/entity/Q102836",
          "target_label": "Latent heat",
          "alignment_type": "skos:broadMatch",
          "provenance": "manual_curation_v1"
        }
      ],
      "curricula": [
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 9,
          "track": "I",
          "subject": "physik",
          "topic_code": "lb2",
          "topic_title": "Wärmelehre",
          "exam_relevant": true
        },
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 9,
          "track": "II_III",
          "subject": "physik",
          "topic_code": "lb2",
          "topic_title": "Wärmelehre",
          "exam_relevant": true
        }
      ],
      "practice_items": [
        {
          "id": "01K4W9P0000000000000000J05",
          "language": "de",
          "tier": "tier1_fast",
          "bloom_level": 1,
          "question": "Steigt die Temperatur eines reinen Stoffs (z. B. Eis/Wasser) während des Schmelzvorgangs bei konstanter Wärmezufuhr weiter an?",
          "concept": "Nein, Temperatur bleibt konstant auf Schmelztemperatur (latente Wärme)",
          "fast_check": {
            "type": "binary_choice",
            "options": [
              "Nein, die Temperatur bleibt bis zum vollständigen Schmelzen konstant",
              "Ja, die Temperatur steigt kontinuierlich an"
            ],
            "correct_index": 0
          }
        },
        {
          "id": "01K4W9P0000000000000000J06",
          "language": "de",
          "tier": "tier2_synthesis",
          "bloom_level": 2,
          "question": "Erkläre die Begriffe Schmelzwärme Q_s und Verdampfungswärme Q_v und warum die zugeführte Energie bei Phasenübergängen keine Temperaturerhöhung bewirkt.",
          "concept": "Q_s = q_s * m; Energie wird zum Lösen von Gitter-/Zwischenmolekularen Bindungen genutzt",
          "sample_solution": "Die Schmelzwärme Q_s = q_s * m ist die Energie, die nötig ist, um einen festen Stoff der Masse m bei seiner Schmelztemperatur vollständig zu verflüssigen. Die Verdampfungswärme Q_v = q_v * m überführt die Flüssigkeit in Dampf. Während der Phasenumwandlung steigt die Temperatur nicht, weil die zugeführte Energie vollständig zum Aufbrechen der zwischenmolekularen Bindungen (Gitterbindungen) genutzt wird (Erhöhung der potenziellen Teilchenenergie)."
        }
      ]
    },
    {
      "id": "01K4W9P0000000000000000A04",
      "atom_uri": "urn:zam:atom:01K4W9P0000000000000000A04",
      "namespace": "physik-waerme",
      "slug": "erster-hauptsatz-mischungstemperatur",
      "title": "Erster Hauptsatz der Wärmelehre und Mischungstemperatur",
      "domain": "schule/physik/waerme",
      "reduction": "classical",
      "typical_age_min": 14.0,
      "prerequisites": [
        {
          "atom_id": "01K4W9P0000000000000000A02",
          "type": "hard",
          "rationale": "Spezifische Wärmekapazität ist Voraussetzung für die Mischungsgleichung."
        }
      ],
      "alignments": [
        {
          "target_uri": "http://www.wikidata.org/entity/Q179261",
          "target_label": "First law of thermodynamics",
          "alignment_type": "skos:exactMatch",
          "provenance": "manual_curation_v1"
        }
      ],
      "curricula": [
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 9,
          "track": "I",
          "subject": "physik",
          "topic_code": "lb2",
          "topic_title": "Wärmelehre",
          "exam_relevant": true
        },
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 9,
          "track": "II_III",
          "subject": "physik",
          "topic_code": "lb2",
          "topic_title": "Wärmelehre",
          "exam_relevant": true
        }
      ],
      "practice_items": [
        {
          "id": "01K4W9P0000000000000000J07",
          "language": "de",
          "tier": "tier1_fast",
          "bloom_level": 1,
          "question": "Wie lautet die Energiebilanz für ein wärmeisoliertes Mischsystem zweier Flüssigkeiten ohne Aggregatzustandswechsel?",
          "concept": "Q_abgegeben = Q_aufgenommen",
          "fast_check": {
            "type": "binary_choice",
            "options": [
              "Q_abgegeben = Q_aufgenommen (Energieerhaltung)",
              "Q_abgegeben > Q_aufgenommen"
            ],
            "correct_index": 0
          }
        },
        {
          "id": "01K4W9P0000000000000000J08",
          "language": "de",
          "tier": "tier2_synthesis",
          "bloom_level": 2,
          "question": "Formuliere den 1. Hauptsatz der Wärmelehre (ΔU = W + Q) und die Richmannsche Mischungsregel für zwei Wassermengen m_1 und m_2 mit Temperaturen T_1 und T_2.",
          "concept": "ΔU = W + Q; T_m = (m_1*T_1 + m_2*T_2) / (m_1 + m_2)",
          "sample_solution": "Der 1. Hauptsatz besagt, dass sich die innere Energie U eines geschlossenen Systems durch Verrichtung mechanischer Arbeit W oder Zufuhr von Wärme Q ändert: ΔU = W + Q. Für das Mischen zweier gleicher Stoffe (gleiches c, z. B. Wasser) in einem isolierten Kalorimeter gilt: c*m_1*(T_1 - T_m) = c*m_2*(T_m - T_2), woraus die Mischungstemperatur T_m = (m_1*T_1 + m_2*T_2) / (m_1 + m_2) folgt."
        }
      ]
    },
    {
      "id": "01K4W9P0000000000000000A05",
      "atom_uri": "urn:zam:atom:01K4W9P0000000000000000A05",
      "namespace": "physik-waerme",
      "slug": "waermeuebertragungsarten",
      "title": "Wärmeübertragung: Wärmeleitung, Konvektion und Wärmestrahlung",
      "domain": "schule/physik/waerme",
      "reduction": "classical",
      "typical_age_min": 14.0,
      "prerequisites": [
        {
          "atom_id": "01K4W9P0000000000000000A01",
          "type": "hard",
          "rationale": "Das Teilchenmodell und thermische Energie sind Voraussetzung für die Transportmechanismen."
        }
      ],
      "alignments": [
        {
          "target_uri": "http://www.wikidata.org/entity/Q179635",
          "target_label": "Heat transfer",
          "alignment_type": "skos:broadMatch",
          "provenance": "manual_curation_v1"
        }
      ],
      "curricula": [
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 9,
          "track": "I",
          "subject": "physik",
          "topic_code": "lb2",
          "topic_title": "Wärmelehre",
          "exam_relevant": true
        },
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 9,
          "track": "II_III",
          "subject": "physik",
          "topic_code": "lb2",
          "topic_title": "Wärmelehre",
          "exam_relevant": true
        }
      ],
      "practice_items": [
        {
          "id": "01K4W9P0000000000000000J09",
          "language": "de",
          "tier": "tier1_fast",
          "bloom_level": 1,
          "question": "Welche Form der Wärmeübertragung benötigt als einzige kein materielles Trägermedium und breitet sich auch im Vakuum des Weltalls aus?",
          "concept": "Wärmestrahlung (elektromagnetische Infrarotstrahlung)",
          "fast_check": {
            "type": "binary_choice",
            "options": [
              "Wärmestrahlung (elektromagnetische Strahlung)",
              "Wärmeleitung"
            ],
            "correct_index": 0
          }
        },
        {
          "id": "01K4W9P0000000000000000J10",
          "language": "de",
          "tier": "tier2_synthesis",
          "bloom_level": 2,
          "question": "Vergleiche die drei Mechanismen der Wärmeübertragung (Wärmeleitung, Konvektion/Wärmeströmung, Wärmestrahlung) hinsichtlich des Teilchentransports.",
          "concept": "Leitung = Stoß ohne Stofftransport; Konvektion = mit Stofftransport; Strahlung = Welle/Photonen ohne Medium",
          "sample_solution": "1. Wärmeleitung: Energieübertragung durch Stöße benachbarter Teilchen in Festkörpern ohne Stofftransport (z. B. Metalllöffel im Heißwasser). 2. Wärmeströmung (Konvektion): Wärmeübertragung durch tatsächliche Bewegung erwärmter Flüssigkeits- oder Gasvolumina (Dichteunterschiede, z. B. Heizkörperthermik). 3. Wärmestrahlung: Energieübertragung durch elektromagnetische Infrarotwellen, die völlig ohne Materie durch das Vakuum erfolgt (z. B. Sonnenstrahlung)."
        }
      ]
    }
  ]
}
